/** @format */

import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { carStates } from 'src/config';
import { Layout as DashboardLayout } from 'src/layouts/dashboard';

// const IndexPage = lazy(() => import('src/pages/dashboard/index'));
// const IndexPage = lazy(() => import('src/pages/monitoring'));
const ProfilePage = lazy(() => import('src/pages/account/my-profile'));

// Management
const BookingSchedule = lazy(() => import('src/pages/management/booking-schedule'));
const Test = lazy(() => import('src/pages/management/test'));
const Schedule = lazy(() => import('src/pages/management/sections/schedule/calendar'));
const Analytic = lazy(() => import('src/pages/management/analytic'));
const User = lazy(() => import('src/pages/management/user'));
const Car = lazy(() => import('src/pages/management/car'));
const CarView = lazy(() => import('src/pages/management/sections/car/item/detail'));
const CarCreate = lazy(() => import('src/pages/management/sections/car/item/create'));
const CarEdit = lazy(() => import('src/pages/management/sections/car/item/edit'));

//Bookibg
const BookingList = lazy(() => import('src/pages/booking/list'));

//Configuration

const BasicFee = lazy(() => import('src/pages/configuration/cost/basic-fee'));
const OperatingCost = lazy(() => import('src/pages/configuration/cost/operating-cost'));

const CarBrand = lazy(() => import('src/pages/configuration/car/brand'));
const CarModel = lazy(() => import('src/pages/configuration/car/model'));
const CarSpecification = lazy(() => import('src/pages/configuration/car/specification'));
const CarFeature = lazy(() => import('src/pages/configuration/car/feature'));

export const pageRoutes = [
  {
    path: '/',
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <BookingSchedule />
      },

      {
        path: 'account',
        children: [
          {
            index: true,
            element: <ProfilePage />
          },

          {
            path: 'profile',
            element: <ProfilePage />
          }
          // {
          //   path: ':postId',
          //   element: <BlogPostDetailPage />,
          // },
        ]
      },
      {
        path: 'management',
        children: [
          {
            path: 'overview',
            children: [
              {
                index: true,
                element: <BookingSchedule />
              },
              {
                path: ':param',
                element: <BookingSchedule />
              }
            ]
          },

          {
            path: 'test',
            element: <Test />
          },
          {
            path: 'schedule',
            element: <Schedule />
          },
          {
            path: 'analytic',
            element: <Analytic />
          },
          {
            path: 'car',
            children: [
              {
                index: true,
                element: <Car />
              },
              {
                path: 'new',
                element: <CarCreate />
              },
              {
                path: carStates.ontour,
                element: <Car tab={carStates.ontour} />
              },

              {
                path: carStates.available,
                element: <Car tab={carStates.available} />
              },

              {
                path: carStates.scheduele,
                element: <Car tab={carStates.scheduele} />
              },

              {
                path: ':carId',
                element: <CarView />
              },
              {
                path: ':carId/edit',
                element: <CarEdit />
              }
            ]
          },
          {
            path: 'user',
            // element: <User />,
            children: [
              {
                index: true,
                element: <User />
              },

              {
                path: ':userId',
                element: <User />
              }
            ]
          }
        ]
      },
      {
        path: 'booking',
        children: [
          {
            index: true,
            element: <BookingList />
          }
        ]
      },
      {
        path: 'configuration',
        children: [
          {
            path: 'cost',
            children: [
              {
                path: 'basic',
                element: <BasicFee />
              },
              {
                path: 'operating',
                element: <OperatingCost />
              }
            ]
          },

          {
            path: 'car',
            children: [
              {
                path: 'brand',
                element: <CarBrand />
              },
              {
                path: 'model',
                element: <CarModel />,
                children: [
                  {
                    index: true,
                    element: <CarModel />
                  },
                  {
                    path: ':brandKey',
                    element: <CarModel />
                  }
                ]
              },

              {
                path: 'specification',
                element: <CarSpecification />
              },
              {
                path: 'features',
                element: <CarFeature />
              }
            ]
          }
        ]
      }
    ]
  }
];
